import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import { useConfig } from '../../../DataStore/ConfigContext';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { useTheme } from '../../../DataStore/ThemeContext';

const Assessments = () => {
    const { openSettings } = useTheme();
    const [activeRecord, setActiveRecord] = useState(null);
    const { getAssessments, assessmentList } = useConfig(); // Use correct method & data

    useEffect(() => {
        getAssessments();
    }, []);

    const handleNew = () => {
        openSettings("New Assessment", "ConfigNewAssessment");
    };

    const handleEdit = () => {
        openSettings("Edit Assessment", "ConfigEditAssessment", activeRecord);
    };

    const handleRefresh = () => {
        setActiveRecord(null);
        getAssessments(true);
    };

    const menu = () => (
        <>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleNew}>
                <i className="dropdown-icon fa fa-plus-circle"></i>
                <span>New Assessment</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" disabled={!activeRecord} onClick={handleEdit}>
                <i className="dropdown-icon fa fa-edit text-primary"></i>
                <span>Edit Selection</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleRefresh}>
                <i className="dropdown-icon fa fa-sync text-primary"></i>
                <span>Refresh</span>
            </button>
        </>
    );

    return (
        <SettingContainer title="Assessment List" icon="fa fa-edit" Menu={menu}>
            <div className="table-responsive">
                <table className="align-middle ml-3 mb-3 table table-borderless table-striped table-hover">
                    <thead>
                        <tr>
                            <th className="text-left">Exam Name</th>
                            <th className="text-left">Description</th>
                            <th className="text-left">Assessment Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(assessmentList) && assessmentList.length > 0 ? (
                            assessmentList.map((item) => (
                                <tr
                                    key={item.id}
                                    onClick={() => setActiveRecord(item)}
                                    className={`${item.id === activeRecord?.id ? 'row-active' : ''}`}
                                >
                                    <td className="text-left">{item.exam_name}</td>
                                    <td className="text-left">{item.description}</td>
                                    <td className="text-left">{item.assessment_type?.type_name || '-'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-muted text-center">
                                    No assessments found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {assessmentList === '404' && <Notification message="No assessments found" />}
                {!assessmentList && <ActivityLoader />}
            </div>
        </SettingContainer>
    );
};

export default Assessments;
